export const LAYOUT_SIZES = {
    HEADER_HEIGHT: 80
};
